import AppleIcon from "../../assets/icons/appleIcon.svg";
import MicrosoftIcon from "../../assets/icons/microsoftIcon.svg";

export const WorkExperience = () => {
  return (
    <section className="flex flex-col flex-1 gap-6 ">
      <article className="flex flex-col gap-5">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col  bg-[#FDFDFD] rounded-xl border border-gray-200 ">
            <div className="flex flex-col gap-0.5 w-full">
              <h2 className="flex-1 gap-4 px-5 pt-3 pb-2 text-sm font-semibold leading-5 text-gray-900">
                Work Experience
              </h2>
              <div className="flex flex-col bg-white rounded-xl border border-gray-200 ">
                <div className="flex flex-col gap-5 p-5">
                  <div className="flex gap-3 bg-white">
                    <div className="flex gap-2.5 items-start pt-1.5">
                      <img
                        src={MicrosoftIcon}
                        alt="Microsoft"
                        className="w-[36px] h-[36px]"
                      />
                    </div>
                    <div className="flex flex-col flex-1 gap-2">
                      <div className="flex flex-col gap-1">
                        <h3 className="text-lg font-semibold tracking-wide leading-7 text-gray-900">
                          Front End Developer
                        </h3>
                        <p className="text-base font-medium leading-6 text-gray-600">
                          Microsoft | Sep 2022 - Present | Full time
                        </p>
                      </div>
                      <p className="text-base leading-6 text-gray-600">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat.
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3 bg-white">
                    <img
                      src={AppleIcon}
                      alt="Apple"
                      className="w-[35px] h-[50px]"
                    />
                    <div className="flex flex-col flex-1 gap-2">
                      <div className="flex flex-col gap-1">
                        <h3 className="text-lg tracking-wide font-semibold leading-7 text-gray-900">
                          Front End Developer
                        </h3>
                        <p className="text-base font-medium leading-6 text-gray-600">
                          Apple | Sep 2021 - Sep 2022 | Full time
                        </p>
                      </div>
                      <p className="text-base leading-6 text-gray-600">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea
                        commodo consequat.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
